"use client";
import { getBaseUrl } from "@/util/get-base-url";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

interface GalleryBannerProps {
    imageBannerUrl: string;
    imageAlt: string;
    width: number;
    height: number;
    priorityImage: boolean;
}

const galleryBanner = (props: GalleryBannerProps) => {

    const { imageBannerUrl, imageAlt, width, height, priorityImage } = props;
    const { hasMouseMoved } = useMouseMovement();
    return (
        hasMouseMoved ? (
            <picture>
                <source srcSet={`${getBaseUrl(imageBannerUrl || "")}.avif`} type="image/avif" />
                <source srcSet={`${getBaseUrl(imageBannerUrl || "")}.webp`} type="image/webp" />
                <img
                    src={imageBannerUrl}
                    alt={imageAlt}
                    loading={priorityImage ? "eager" : "lazy"}
                    fetchPriority={priorityImage ? "high" : "auto"}
                    style={{ objectFit: "cover" }}
                    width={width}
                    height={height}
                    className="w-full h-auto"
                />
            </picture>
        ): <div className={`w-full h-[300px] sm:h-[600px] bg-gray-300`} />
    )
}

export default galleryBanner;